export default {
	name: 'اسم المرفق',
	type: 'نوعه',
	addAttachments: 'إضافة مرفق',
};
